// extracted by mini-css-extract-plugin
module.exports = {"customActiveShapePieContainer":"CustomActiveShapePie_customActiveShapePieContainer__8E9dR"};